export default __webpack_public_path__ + "assets/images/Symbian-logo-small.png";